var filters = {
    selectors: {
        filterSelector: '.package-filter',
    },

    init: function () {
        this.filterPackages();
        this.filterRooms();

        $(window).on('hashchange', function () {
            this.filterPackages();
        }.bind(this));
    },

    filterPackages: function () {
        var hash = window.location.hash,
            containsAmpersand = hash.indexOf('&'),
            containsQuestionMark = hash.indexOf('?');

        hash = hash.substring(0, containsAmpersand !== -1 ? containsAmpersand : hash.length);
        hash = hash.substring(0, containsQuestionMark !== -1 ? containsQuestionMark : hash.length);

        var syrIdsToShow = (hash.replace('#', '').replace('/', '').split('-'));
        var $package = $('.package-item');
        $('.package-filter .filter-button').removeClass('active');

        syrIdsToShow.splice(0, 1);

        if (syrIdsToShow.length) {
            $package.hide();
            $(syrIdsToShow).each(function (index, syrId) {
                var filterBtn = $('.package-filter .filter-button[data-filter-syr-ids*=' + syrId + ']');
                $('.package-item[data-syr-ids*=' + syrId + ']').fadeIn();
                $(filterBtn).addClass('active');
            })
        } else {
            $package.fadeIn();
        }
    },

    filterRooms: function () {
        var room = $('.room-item'),
            filterBtn = $('.rooms-filter-button');

        filterBtn.click(function () {
            var checkedInputIds = $('.filter-list-facility input[type="checkbox"]:checked').map(function () {
                return this.id.replace(/\D/g, '');
            }).get().join(',');

            var bedsCountFilter = parseInt($('#bedsCount').val());
            var bedroomsCountFilter = parseInt($('#bedroomsCount').val());
            var roomsCountFilter = parseInt($('#roomsCount').val());

            room.hide().filter(function () {
                var dataBeds = parseInt($(this).data('beds'));
                var dataBedrooms = parseInt($(this).data('bedrooms'));
                var dataRooms = parseInt($(this).data('rooms'));
                var dataPropIds = $(this).data('prop-ids');
                var numericArray1 = checkedInputIds.split(',').map(Number);
                var dataPropIdsArray = dataPropIds ? dataPropIds.split(',').map(Number) : [];

                return (!bedsCountFilter || dataBeds === bedsCountFilter) &&
                    (!bedroomsCountFilter || dataBedrooms === bedroomsCountFilter) &&
                    (!roomsCountFilter || dataRooms === roomsCountFilter) &&
                    (!checkedInputIds || numericArray1.every(function (value) {
                        return dataPropIdsArray.indexOf(value) !== -1;
                    }));
            }).fadeIn();
        });

        $('.quantity-control .plus, .quantity-control .minus').on('click', function () {
            var input = $(this).siblings('input');
            var currentValue = parseInt(input.val());

            if ($(this).hasClass('plus')) {
                input.val(currentValue + 1);
            } else if (currentValue > 0) {
                input.val(currentValue - 1);
            }
        });
    },
};

export { filters };